'use client';
import { Button, Text, Title, Flex } from '@gjensidige/builders-components';
import { TrustpilotLogo, TrustpilotStars } from '../shared/trustpilot';
import type { HeaderCtaProps as Props } from './types';
import styles from './header-cta.module.less';

export const HeaderCta = ({
  buttons,
  image,
  layout,
  partnerLogo,
  preface,
  stars,
  title
}: Props) => (
  <Flex
    as="header"
    center
    layout={{ xs: 1, md: layout === 'full' || !image ? 1 : 2 }}
    direction={layout === 'right' ? 'row-reverse' : 'row'}
    align="end"
    gap="lg xl"
    className={styles.marginBHeaders}
  >
    {!!image && (
      <img
        alt={image.alt || ''}
        className={styles[layout == 'full' ? 'fullPhoto' : 'photo']}
        height={9}
        src={image.url}
        srcSet={image.srcset}
        width={16}
        sizes={
          image.srcset &&
          `(min-width: 1200px) and (max-width: 1619px) 600px,
            (min-width: 1620px) 800px,
            100vw`
        }
      />
    )}
    <Flex
      align="start"
      gap="sm xl"
      layout={{ xs: 1, md: layout === 'full' || !image ? 2 : 1 }}
      justify="end"
    >
      <Flex layout="1" gap="xs">
        {!!partnerLogo && (
          <div>
            <img
              src={partnerLogo.url}
              srcSet={partnerLogo.srcset}
              alt={partnerLogo.alt || ''}
              width={120}
              height={30}
            />
          </div>
        )}
        <Title className={styles.title} size="2" as="h1" text={title} />
        {!!stars && (
          <Flex align="center" gap="sm">
            {!!stars.showStars && <TrustpilotStars score={stars.trustScore} />}
            <Text size="large" weight={700}>
              {stars.trustScore} / 5
            </Text>
            <TrustpilotLogo />
          </Flex>
        )}
      </Flex>
      <Flex layout="1" gap="md">
        {!!preface && (
          <Text
            as="div"
            className={styles.htmlArea}
            dangerouslySetInnerHTML={{ __html: preface }}
            size="large"
          />
        )}
        {!!buttons && (
          <Flex gap="xs sm">
            {buttons.map(({ text, url, trackingLabel }, index) => (
              <Button
                href={url}
                key={index}
                variant={
                  buttons?.length === 1
                    ? 'critical'
                    : index
                    ? 'secondary'
                    : 'primary'
                }
                tracking={
                  !!trackingLabel && {
                    eventLabel: trackingLabel
                  }
                }
              >
                {text}
              </Button>
            ))}
          </Flex>
        )}
      </Flex>
    </Flex>
  </Flex>
);
